var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50977 4.02881C6.20663 6.27906 8.92124 8.32236 11.8655 10.2339C13.0269 10.988 14.1365 11.8017 15.2442 12.6312C15.7681 13.0235 16.3073 13.3762 16.7352 13.8755",
    stroke: "#FF782C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3839 2.77393C14.3353 4.02225 13.2131 5.30695 11.9783 6.37257C10.5994 7.56261 9.41846 8.90341 7.93988 9.97658C7.30509 10.4373 6.73113 10.9408 6.13787 11.4514C5.48796 12.0108 4.73267 12.4199 4.09989 12.996C3.49254 13.549 2.77817 14.0004 2.15845 14.5513",
    stroke: "#FF782C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.14525C2.11446 9.43285 3.2961 9.33832 4.43775 9.33832C5.76411 9.33832 7.08605 9.25815 8.41182 9.24178C10.1327 9.22054 11.9146 9.19337 13.6248 8.98435C14.2876 8.90334 14.8879 8.69202 15.5555 8.66257C16.1569 8.63603 16.719 8.35583 17.3146 8.27642C17.6523 8.23139 18.0119 8.22642 18.3443 8.15844C18.7704 8.07127 19.0914 7.98682 19.5349 7.98682",
    stroke: "#FF782C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59189 1.61523C9.31703 5.15409 9.49535 8.74963 9.49535 12.2985C9.49535 13.2335 9.49535 14.1685 9.49535 15.1035C9.49535 15.4774 9.37645 16.0621 9.59189 16.3852",
    stroke: "#FF782C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.edaee5ec4911dcbff45b70ee983d0e7f.svg";
export { ForwardRef as ReactComponent };